import styled from 'styled-components';

/**
 * This component is used when there are multiple form
 * inputs in the same row.
 *
 * Currently according to Figma design, all inputs in
 * the same row are spaced equaly, but this can be changed
 * by giving specific width to one element, and maximum
 * width to all other elements in a row if needed.
 */
export const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  gap: 2rem;
`;
